function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 155.888,
  cy: 20.3622,
  rx: 140.112,
  ry: 4.36238,
  transform: "rotate(-180 155.888 20.3622)",
  fill: "url(#paint0_radial)",
  fillOpacity: 0.73
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  x: 0.614427,
  y: 0.837449,
  width: 310.548,
  height: 39.0496,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.58121,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_radial",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(155.888 20.3622) rotate(90) scale(4.36238 159.91)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1B678B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854167,
  stopColor: "#1F678A",
  stopOpacity: 0
})));

const SvgShadow = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 280,
  height: 40,
  viewBox: "0 0 312 40",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShadow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shadow.f87d9814.svg";
export { ForwardRef as ReactComponent };